import ErrorFeedbackScreen from '../../components/shared/ErrorFeedbackScreen/ErrorFeedbackScreen';
import ErrorRoundImage from '../../assets/images/error-round.webp';
import { CloseWebviewEvent } from '../../sdk/close.webview.event';
import useTranslation from '../../localization/i18n.context';
import NavigationUtils from '../../utils/navigation.utils';

export default function ResetPinErrorPage({ cardUid }) {
  const { t } = useTranslation();

  const closeWebview = () => {
    CloseWebviewEvent.finishWithError();
  };

  const restartFlow = () => {
    NavigationUtils.navigate(NavigationUtils.Routes.RESET_PIN, true, {
      cardUid,
    });
  };

  return (
    <ErrorFeedbackScreen
      onCloseClick={closeWebview}
      image={ErrorRoundImage}
      title={t('Something went wrong')}
      text={t("We couldn't update your PIN")}
      subtitle={t('Please check your internet connection and try again')}
      ctaAction={restartFlow}
      ctaText={t('Try Again')}
    />
  );
}
